module.exports = __webpack_public_path__ + "img/00037.c2f12888.webp";